// components/AnswerField.jsx
import React from "react";
import { Box, TextField, FormLabel, Typography } from "@mui/material";

const AnswerField = ({
  module,
  answer,
  isEditable,
  fieldKey,
  type,
  onChange,
}) => {
  const isLong = type === "long_answer";

  // Long-answer labels are often full instructions/observations. A floating MUI
  // label collapses to a single line and truncates with an ellipsis, so render
  // the label as a wrapping block above the field instead (matches the
  // InspectionItemField layout).
  if (isLong) {
    return (
      <Box sx={{ mt: 2, mb: 1 }}>
        <FormLabel
          sx={{
            display: "block",
            mb: 0.75,
            fontWeight: 500,
            color: "text.primary",
            fontSize: "0.9rem",
            whiteSpace: "normal",
            lineHeight: 1.4,
          }}
        >
          {module.label}
          {module.required && (
            <Typography component="span" color="error" sx={{ ml: 0.25 }}>
              *
            </Typography>
          )}
        </FormLabel>
        <TextField
          value={answer || ""}
          onChange={(e) => onChange(fieldKey, e.target.value)}
          fullWidth
          required={module.required}
          multiline
          rows={4}
          InputProps={{ readOnly: !isEditable }}
          disabled={!isEditable}
        />
      </Box>
    );
  }

  return (
    <TextField
      label={module.label}
      value={answer || ""}
      onChange={(e) => onChange(fieldKey, e.target.value)}
      fullWidth
      required={module.required}
      margin="normal"
      InputProps={{ readOnly: !isEditable }}
      disabled={!isEditable}
    />
  );
};

export default AnswerField;
